import { SlideIndexProvider } from '../hooks/useSlideIndex';
import { DebugPhaseProvider } from './DebugPhaseContext';
import { DeepgramDebugProvider } from './DeepgramDebugContext';
import { EndSessionDebugProvider } from './EndSessionDebugContext';
import { SessionUserProvider } from './SessionUserContext';
import { TranscricaoProvider } from './TranscricaoContext';

export default function GlobalProviders({ children }) {
  return (
    <SlideIndexProvider>
      <TranscricaoProvider>
        <DeepgramDebugProvider>
          <EndSessionDebugProvider>
            <DebugPhaseProvider>
              <SessionUserProvider>
                {children}
              </SessionUserProvider>
            </DebugPhaseProvider>
          </EndSessionDebugProvider>
        </DeepgramDebugProvider>
      </TranscricaoProvider>
    </SlideIndexProvider>
  );
}
